import { __assign } from "tslib";
import { lightTheme, MeetingProvider } from 'amazon-chime-sdk-component-library-react';
import { LogLevel } from 'amazon-chime-sdk-js';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { InitMeeting } from './init-meeting';
import { SessionProvider } from './session-provider';
import { SignalManager } from './signal-manager';
import { SyncProps } from './sync-props';
import { Video } from './video';
import { VideoConfigProvider } from './video-config-provider';
export default (function (props) { return (React.createElement(ThemeProvider, { theme: lightTheme },
    React.createElement(MeetingProvider, { logLevel: LogLevel.ERROR, spectator: !props.dashboard && props.webinar, simulcastEnabled: true },
        React.createElement(VideoConfigProvider, __assign({}, props),
            React.createElement(InitMeeting, null,
                React.createElement(SessionProvider, null,
                    React.createElement(Video, null)),
                React.createElement(SyncProps, null),
                React.createElement(SignalManager, null)))))); });
//# sourceMappingURL=index.js.map